const resource = {
  resources: "Ressourcen",
  resource: "Ressource",
  type: "Typ",
  name: "Name der Ressource",
  description: "Beschreibung",
  linkToDocument: "Link zum Dokument",
  missingLink: "Link fehlt",
};

export default resource;
